export const WORKER_LEAVE_REQUEST_FETCH_BEGIN = 'syftacp/WORKER_LEAVE_REQUEST_FETCH_BEGIN'
export const WORKER_LEAVE_REQUEST_FETCH_CSV = 'syftacp/WORKER_LEAVE_REQUEST_FETCH_CSV'
export const WORKER_LEAVE_REQUEST_FETCH_SUCCEEDED = 'syftacp/WORKER_LEAVE_REQUEST_FETCH_SUCCEEDED'
export const WORKER_LEAVE_REQUEST_FETCH_FAILED = 'syftacp/WORKER_LEAVE_REQUEST_FETCH_FAILED'
export const WORKER_LEAVE_REQUEST_CHANGE_STATUS_BEGIN = 'syftacp/WORKER_LEAVE_REQUEST_CHANGE_STATUS_BEGIN'
export const WORKER_LEAVE_REQUEST_CHANGE_STATUS_SUCCEEDED = 'syftacp/WORKER_LEAVE_REQUEST_CHANGE_STATUS_SUCCEEDED'
export const WORKER_LEAVE_REQUEST_CHANGE_STATUS_FAILED = 'syftacp/WORKER_LEAVE_REQUEST_CHANGE_STATUS_FAILED'
